// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LangRouteImport } from './routes/$lang'
import { Route as AboutRouteImport } from './routes/about'
import { Route as DeleteRouteImport } from './routes/delete'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as SupportRouteImport } from './routes/support'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as BibleIndexRouteImport } from './routes/bible.index'
import { Route as BibleSlugRouteImport } from './routes/bible.$slug'
import { Route as BlockIndexRouteImport } from './routes/block.index'
import { Route as BlockSlugRouteImport } from './routes/block.$slug'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as PostIdRouteImport } from './routes/post.$id'
import { Route as PrayersIndexRouteImport } from './routes/prayers.index'
import { Route as PrayersSlugRouteImport } from './routes/prayers.$slug'
import { Route as QuizIndexRouteImport } from './routes/quiz.index'
import { Route as QuizSlugRouteImport } from './routes/quiz.$slug'
import { Route as RequestIdRouteImport } from './routes/request.$id'
import { Route as VerseIndexRouteImport } from './routes/verse.index'
import { Route as VerseSlugRouteImport } from './routes/verse.$slug'
import { Route as VersesIndexRouteImport } from './routes/verses.index'
import { Route as VersesSlugRouteImport } from './routes/verses.$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const LangRoute = LangRouteImport.update({
            id: '/$lang',path: '/$lang',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const DeleteRoute = DeleteRouteImport.update({
            id: '/delete',path: '/delete',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const SupportRoute = SupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const BibleIndexRoute = BibleIndexRouteImport.update({
            id: '/bible/',path: '/bible/',getParentRoute: () => rootRouteImport
          })
const BibleSlugRoute = BibleSlugRouteImport.update({
            id: '/bible/$slug',path: '/bible/$slug',getParentRoute: () => rootRouteImport
          })
const BlockIndexRoute = BlockIndexRouteImport.update({
            id: '/block/',path: '/block/',getParentRoute: () => rootRouteImport
          })
const BlockSlugRoute = BlockSlugRouteImport.update({
            id: '/block/$slug',path: '/block/$slug',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const PostIdRoute = PostIdRouteImport.update({
            id: '/post/$id',path: '/post/$id',getParentRoute: () => rootRouteImport
          })
const PrayersIndexRoute = PrayersIndexRouteImport.update({
            id: '/prayers/',path: '/prayers/',getParentRoute: () => rootRouteImport
          })
const PrayersSlugRoute = PrayersSlugRouteImport.update({
            id: '/prayers/$slug',path: '/prayers/$slug',getParentRoute: () => rootRouteImport
          })
const QuizIndexRoute = QuizIndexRouteImport.update({
            id: '/quiz/',path: '/quiz/',getParentRoute: () => rootRouteImport
          })
const QuizSlugRoute = QuizSlugRouteImport.update({
            id: '/quiz/$slug',path: '/quiz/$slug',getParentRoute: () => rootRouteImport
          })
const RequestIdRoute = RequestIdRouteImport.update({
            id: '/request/$id',path: '/request/$id',getParentRoute: () => rootRouteImport
          })
const VerseIndexRoute = VerseIndexRouteImport.update({
            id: '/verse/',path: '/verse/',getParentRoute: () => rootRouteImport
          })
const VerseSlugRoute = VerseSlugRouteImport.update({
            id: '/verse/$slug',path: '/verse/$slug',getParentRoute: () => rootRouteImport
          })
const VersesIndexRoute = VersesIndexRouteImport.update({
            id: '/verses/',path: '/verses/',getParentRoute: () => rootRouteImport
          })
const VersesSlugRoute = VersesSlugRouteImport.update({
            id: '/verses/$slug',path: '/verses/$slug',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,LangRoute: LangRoute,AboutRoute: AboutRoute,DeleteRoute: DeleteRoute,PrivacyRoute: PrivacyRoute,SupportRoute: SupportRoute,TermsRoute: TermsRoute,BibleSlugRoute: BibleSlugRoute,BlockSlugRoute: BlockSlugRoute,BlogSlugRoute: BlogSlugRoute,PostIdRoute: PostIdRoute,PrayersSlugRoute: PrayersSlugRoute,QuizSlugRoute: QuizSlugRoute,RequestIdRoute: RequestIdRoute,VerseSlugRoute: VerseSlugRoute,VersesSlugRoute: VersesSlugRoute,BibleIndexRoute: BibleIndexRoute,BlockIndexRoute: BlockIndexRoute,BlogIndexRoute: BlogIndexRoute,PrayersIndexRoute: PrayersIndexRoute,QuizIndexRoute: QuizIndexRoute,VerseIndexRoute: VerseIndexRoute,VersesIndexRoute: VersesIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)